// extracted by mini-css-extract-plugin
export default {"hamburgerIcon":"hamburgerIcon_dvBd","open":"open_Rx5P","line1":"line1_qCxy","line3":"line3_Dc82","line2":"line2_zGvx","line":"line_hZ9I"};